<template>
  <div class="container">
    <h1 class="title">Wertgutscheine</h1>
    <h2 class="subtitle">
      Wertgutscheine
    </h2>

    <div class="columns">
      <div class="column ">
        <div class="buttons buttons--end">
          <b-button icon-left="plus-circle" type="is-dark" @click="showModal()"
            >Neuer Wertgutschein
          </b-button>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field>
          <b-input
            placeholder="Suche..."
            icon="search"
            v-model="freeText"
            @keyup.enter.native="search"
          >
          </b-input>
        </b-field>
      </div>
    </div>
    <pre>{{ giftCards }}</pre>

    <CreateGiftCardModal :show="ModalVisible" @close="closeModal" />
  </div>
</template>
<script>
import CreateGiftCardModal from '@/components/giftcards/CreateGiftCardModal'
import giftcardApi from '@/api/giftcard-api'
export default {
  name: 'GiftCards',
  components: {CreateGiftCardModal},
  data() {
    return {
      giftCards: [],
      page: 1,
      pageSize: 16,
      total: 0,
      freeText: '',
      ModalVisible: false,
    }
  },
  async mounted() {
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      const result = await giftcardApi.listGiftCards(
        this.page,
        this.pageSize,
        'default',
        this.freeText,
      )
      this.giftCards = result.results
      this.page = result.page
      this.pageSize = result.pageSize
      this.total = result.total
    },
    showModal() {
      this.ModalVisible = true
    },
    closeModal(item) {
      this.ModalVisible = false
      if (item) {
        this.giftCards.push(item)
      }
    },
    async pageChange(page) {
      this.page = page
      await this.refreshData()
    },
    async search() {
      await this.refreshData()
    },
    async deleteCode(item) {
      await giftcardApi.disableGiftCard(item.id)
      this.reductions = this.giftCards.filter(f => f.id != item.id)
      this.$buefy.toast.open('Deaktiviert!')
    },
  },
}
</script>
